import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { TokenInterceptor } from './token.interceptor';
import { environment } from '../../environments/environment';
import { RuntimeEnvironmentService } from '../services/runtime-environment.service';

function isLegacyBrowser(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1;
}

export function msalInstanceFactory(runtimeEnv: RuntimeEnvironmentService): IPublicClientApplication {
  // Environment is initialized by APP_INITIALIZER before this factory runs
  // Access the already-populated environment values to create MSAL config
  const msalConfig: Configuration = {
    auth: {
      clientId: environment.us_config.clientID,
      authority: environment.us_config.authority,
      redirectUri: environment.us_config.redirectUri,
      postLogoutRedirectUri: `${window.location.origin}/dashboard`,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isLegacyBrowser()
    },
    system: {
      loggerOptions: {
        loggerCallback: () => undefined,
        piiLoggingEnabled: false,
        logLevel: LogLevel.Warning
      }
    }
  };
  
  // Factory ensures Angular DI provides only one MSAL client app instance.
  return new PublicClientApplication(msalConfig);
}

@NgModule({
  imports: [MsalModule],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: msalInstanceFactory,
      deps: [RuntimeEnvironmentService]
    },
    MsalService,
    AuthService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class AuthModule { }
